import { render, staticRenderFns } from "./IndicatorDisplay2.vue?vue&type=template&id=2c74a665&scoped=true&"
import script from "./IndicatorDisplay2.vue?vue&type=script&lang=js&"
export * from "./IndicatorDisplay2.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorDisplay2.vue?vue&type=style&index=0&id=2c74a665&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c74a665",
  null
  
)

export default component.exports